import * as React from 'react';
import { DatePicker } from '../DatePickers';
import { __ } from '../utilities';
import { rem } from 'polished';
import Icon from '../Icon';
import Input from '../Input';
import Segment from '../Segment';
import SegmentHeader from '../Segment/Header';
import SelectFilter from './filters/select';
import Sidebar from '../Sidebar';
import SmarttagsControl from '../SmarttagsControl/SmarttagControl';
import styled, { ThemeProvider, css, useTheme } from 'styled-components';
const WrapperInput = styled('div') `
  position: relative;
  width: 100%;
  border-left: none;
  justify-content: center;
  * {
    border-radius: 0 !important;
    border-top: 0 !important;
    border-right: 0 !important;
    border-left: 0 !important;
  }
  .input-icon {
    background-color: #fff;
  }
`;
const WrapperWoInput = styled(WrapperInput) `
  border-bottom: ${rem(1)} solid ${({ theme }) => theme.separatorColor};
  padding-left: ${({ theme }) => rem(theme.input.horizontalPadding)};
  cursor: pointer;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const WrapperIcon = styled('div') `
  position: relative;
  min-width: ${rem(32)};
  width: ${rem(40)};
  top: 0;
  bottom: 0;
  right: 0;
  border-left: none;
  justify-content: center;
`;
const WrapperCountFilter = styled('div') `
  background: red;
  border-radius: 50% !important;
  color: #fff;
  position: absolute;
  top: 0;
  left: ${rem(4)};
  font-size: ${rem(10)};
  font-weight: bold;
  line-height: ${rem(19)};
  text-align: center;
  white-space: nowrap;
  padding: 0 ${rem(5)};
  min-width: ${rem(17)};
  z-index: 10;
  min-width: ${rem(20)};
`;
const StyledInput = styled(Input) `
  width: 100%;
  height: ${rem(40)};
  &::placeholder {
    color: ${({ theme }) => theme.inactiveColor};
  }
  color: ${({ theme }) => theme.textColor};
  box-shadow: none;
`;
const WrapperButton = styled('div') `
  height: ${rem(48)};
  width: 100%;
  padding: ${rem(14)};
  color: red;
  font-size: ${rem(16)};
  cursor: pointer;
  text-align: center;
  ${({ $disabled }) => $disabled &&
    css `
      color: #e0e0eb;
      cursor: not-allowed;
    `}
`;
const IconButton = styled(Input.Button) `
  width: ${rem(48)};
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
`;
const InputWrapper = styled.div `
  position: relative;
`;
const AutocompleteOptions = styled.ul `
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999999;
  background-color: #fff;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;
const AutocompleteOption = styled.li `
  margin: 0;
  padding: ${rem(10)} ${rem(20)};
  cursor: pointer;

  & * {
    margin: 0;
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.primary};
    color: #fff;
  }

  ${({ $selected }) => $selected &&
    css `
      background-color: ${({ theme }) => theme.color.primary};
      color: #fff;
    `}
`;
const Filter = ({ onChange, value, filters, searchInputButton, autocompleteOptions = [], onInputEnter, onInputChange, onFiltersChange, onOptionsClose, onOptionSelect, }) => {
    const [sidebarOpened, setSidebarOpened] = React.useState(false);
    const theme = useTheme();
    const [focusedOptionIndex, setFocusedOptionIndex] = React.useState(-1);
    const optionRefs = React.useRef([]);
    optionRefs.current = autocompleteOptions.map((_, i) => optionRefs.current[i] ?? React.createRef());
    let queryFilterName = '';
    let queryFilter = null;
    const sidebarFilters = [];
    for (const f of filters) {
        if (f.type === 'query') {
            queryFilter = f;
            queryFilterName = f.name;
        }
        else {
            sidebarFilters.push(f);
        }
    }
    const countFilter = () => {
        let totalCountFilter = 0;
        for (const valueName of Object.keys(value)) {
            if (valueName === queryFilterName) {
                continue;
            }
            const f = value[valueName];
            if (typeof f === 'undefined') {
                continue;
            }
            if (Array.isArray(f)) {
                if (f.length > 0) {
                    totalCountFilter++;
                }
            }
            else {
                if (f === null) {
                }
                else if (typeof f === 'string') {
                    if (f.length === 0) {
                    }
                    else {
                        totalCountFilter++;
                    }
                }
                else if (f.value === '' || f.value === null) {
                }
                else {
                    totalCountFilter++;
                }
            }
        }
        return totalCountFilter;
    };
    const deleteAllSelect = () => {
        if (onChange) {
            if (queryFilter) {
                const nextValue = { [queryFilter.name]: value[queryFilter.name] };
                onChange(nextValue);
            }
            else {
                onChange({});
            }
        }
        onFiltersChange?.({});
    };
    const handleSearch = (e) => {
        if (queryFilter) {
            if (!(onInputChange && onFiltersChange) && onChange) {
                if (queryFilter && e.target.value) {
                    const nextValue = { ...value, [queryFilter.name]: e.target.value };
                    onChange(nextValue);
                }
                else {
                    delete value[queryFilter.name];
                    const nextValue = { ...value };
                    onChange(nextValue);
                }
            }
            onInputChange?.(e.target.value);
        }
    };
    function createSidebarButton() {
        return (React.createElement(IconButton, { onClick: () => {
                setSidebarOpened(!sidebarOpened);
            }, "data-testid": "UI_Filter_Button_Tune", style: { position: 'relative' } },
            React.createElement(Icon, { name: "tune", size: iconSize, color: countOfFilter !== 0
                    ? theme.color.primary
                    : sidebarOpened
                        ? theme.textColor
                        : theme.inactiveColor }),
            countOfFilter !== 0 && (React.createElement(WrapperCountFilter, null, countOfFilter))));
    }
    function createHeadSegment(filter) {
        return (React.createElement(SegmentHeader, { size: "xs", ...filter }, filter.label));
    }
    const handleFilterChange = (filterName, v) => {
        if (!(onFiltersChange && onInputChange) && onChange) {
            onChange({
                ...value,
                [filterName]: v,
            });
        }
        const copyValue = { ...value, [filterName]: v };
        if (queryFilter?.name) {
            delete copyValue[queryFilter.name];
        }
        onFiltersChange?.(copyValue);
    };
    const handleCloseOptions = () => {
        onOptionsClose?.();
        setFocusedOptionIndex(-1);
    };
    const handleInputKeyDown = (event) => {
        const hasOptions = autocompleteOptions.length > 0;
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                if (hasOptions) {
                    setFocusedOptionIndex(prevIndex => Math.min(prevIndex + 1, autocompleteOptions.length - 1));
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (hasOptions) {
                    setFocusedOptionIndex(prevIndex => Math.max((prevIndex ?? 0) - 1, 0));
                }
                break;
            case 'Enter':
                event.preventDefault();
                if (hasOptions &&
                    focusedOptionIndex >= 0 &&
                    autocompleteOptions[focusedOptionIndex]) {
                    const optionValue = autocompleteOptions[focusedOptionIndex].value;
                    onOptionSelect?.(optionValue);
                    setFocusedOptionIndex(-1);
                }
                else {
                    onInputEnter?.();
                }
                break;
            case 'Escape':
                event.preventDefault();
                if (hasOptions) {
                    handleCloseOptions();
                }
                break;
            default:
                break;
        }
    };
    const countOfFilter = countFilter();
    const iconSize = 30;
    function renderFilters() {
        if (!sidebarFilters) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            sidebarFilters.map((filter, idx) => {
                if (filter.type === 'select') {
                    return (React.createElement(Segment, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(SelectFilter, { filter: filter, value: value[filter.name], onChange: v => {
                                handleFilterChange(filter.name, v);
                            } })));
                }
                else if (filter.type === 'smarttag') {
                    return (React.createElement(Segment, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(SmarttagsControl, { ...filter, availableSmarttags: filter.availableSmarttags || [], value: value[filter.name], creatable: false, onChange: (v) => {
                                handleFilterChange(filter.name, v);
                            } })));
                }
                else if (filter.type === 'date') {
                    return (React.createElement(Segment, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(DatePicker, { ...filter, value: value[filter.name]
                                ? new Date(String(value[filter.name]))
                                : null, onChange: (v) => {
                                handleFilterChange(filter.name, v);
                            } })));
                }
                return null;
            }),
            React.createElement(WrapperButton, { onClick: deleteAllSelect, "$disabled": countOfFilter === 0 }, __('Odstrániť filtre'))));
    }
    const inputTheme = React.useMemo(() => {
        return {
            ...theme,
            input: {
                ...theme.input,
                borderColor: theme.separatorColor,
            },
        };
    }, [theme]);
    return (React.createElement(React.Fragment, null,
        queryFilter ? (React.createElement(WrapperInput, null,
            React.createElement(ThemeProvider, { theme: inputTheme },
                React.createElement(InputWrapper, null,
                    React.createElement(StyledInput, { ...queryFilter, type: "text", value: (value[queryFilter.name] ?? ''), onChange: handleSearch, onKeyDown: handleInputKeyDown, autocomplete: "off" },
                        React.createElement(Input.Icon, { className: "input-icon", name: "search", size: iconSize, color: "#000" }),
                        React.createElement("input", null),
                        !!searchInputButton && searchInputButton,
                        createSidebarButton()),
                    autocompleteOptions.length > 0 && (React.createElement(AutocompleteOptions, null, autocompleteOptions.map((option, index) => {
                        return (React.createElement(AutocompleteOption, { key: index, onClick: () => {
                                onOptionSelect?.(option.value);
                            }, onMouseEnter: () => {
                                setFocusedOptionIndex(index);
                            }, "$selected": focusedOptionIndex === index }, option.label));
                    }))))))) : (React.createElement(WrapperWoInput, { onClick: () => {
                setSidebarOpened(!sidebarOpened);
            } },
            React.createElement(Icon, { name: "search", size: iconSize, color: "#000" }),
            createSidebarButton())),
        React.createElement(Sidebar, { header: __('Aktívny filter'), visible: sidebarOpened, onClose: () => {
                setSidebarOpened(false);
            } }, renderFilters())));
};
export default Filter;
